import * as components from './components';
export * from './components';

// 安装函数类型
interface InstallFunction {
  (app: any): void;
}

// 安装函数
const install: InstallFunction = (app: any): void => {
  // 注册所有组件
  Object.keys(components).forEach((key) => {
    const component = components[key as keyof typeof components];
    if (component.install) {
      app.use(component);
    }
  });
};

// 默认导出
export default {
  install,
};
